/**
 * Created by User on 18/02/2016.
 */
import Playlist from './Playlist';
import ExternalEventsDispatcher from './ExternalEventsDispatcher';
import Observer from '../utils/Observer';
import AdConsts from '../AdConsts';
import Utils from '../utils/Utils';
import Loader from '../utils/Loader';

export default AdModel;

function AdModel() {
  var _advertDataUsed = false;
  var _advertData = null;
  var _advertURL = null;
  var _playlist = new Playlist();
  var _externalEventsDispatcher = new ExternalEventsDispatcher(_playlist);

  this.dispose = function() {
    _playlist.dispose();
    _externalEventsDispatcher.dispose();
  };

  this.beginProcessAd = function(advertData, advertURL, player) {
    _advertData = advertData;
    _advertURL = advertURL;

		if(_advertURL) Utils.findDiD(_advertURL, player);

    if (typeof _advertData === 'string') {
      try {
        _advertData = JSON.parse(_advertData);
      } catch (error) {
        _advertData = null;
      }
    }
    if (_advertData) {
      _processJSONPlaylist(_advertData);
    } else if (_advertURL) {
      _advertDataUsed = true;
      _loadPlaylist(_advertURL);
    } else {
      Observer.emit(AdConsts.MODEL_PLAYLIST_LOADING_ERROR);
      Observer.emit(AdConsts.PLAYLIST_INFO, null);
    }
  };

  this.run = function(state, currentTime, duration, sizeInfo) {
    _playlist.run(state, currentTime, duration, null, sizeInfo);
  };

  this.currentMemberCompleted = function() {
    _playlist.currentMemberCompleted();
  };

  this.stopCurrentBlock = function() {
    _playlist.stopCurrentBlock();
  };

  var _loadPlaylist = function(url) {
    if (Utils.isStringWithData(url)) {
      var loader = new Loader();
      loader.load(url, Loader.RESPONSE_TYPE_JSON,
        function(event) { //on success
          if (loader.response) {
            var response = loader.response;
            if (typeof response === 'string') {
              try {
                response = JSON.parse(response);
              } catch (error) {
                Observer.emit(AdConsts.MODEL_PLAYLIST_PARSING_ERROR);
                Observer.emit(AdConsts.PLAYLIST_INFO, null);
              }
            }
            _processJSONPlaylist(response);
          } else {
            Observer.emit(AdConsts.MODEL_PLAYLIST_IS_EMPTY);
            Observer.emit(AdConsts.PLAYLIST_INFO, null);
          }
        }, onError, onError, 10000);

    }
    function onError (event) {
      Observer.emit(AdConsts.MODEL_PLAYLIST_LOADING_ERROR);
      Observer.emit(AdConsts.PLAYLIST_INFO, null);
    }
  };

  var _processJSONPlaylist = function(jsonData) {
    if (Utils.needWeboramaDMP(JSON.stringify(jsonData))) {
      Observer.emit(AdConsts.AD_IMHO_DETECTED, true);
      setTimeout(_onPlaylistReady, 1000, jsonData);
    } else {
      _onPlaylistReady(jsonData);
    }
  };

  var _onPlaylistReady = function(data) {
    Observer.on([ AdConsts.PLAYLIST_READY, AdConsts.PLAYLIST_ERROR ], _onPlaylistEvent);
    _playlist.processPlaylistData(data);
  };

  var _onPlaylistEvent = function(event) {
    switch (event.name) {
      case AdConsts.PLAYLIST_READY:
        Observer.emit(AdConsts.MODEL_READY, event.data);
        break;
      case AdConsts.PLAYLIST_ERROR:
        if (!_advertDataUsed) {
          _advertDataUsed = true;
          _loadPlaylist(_advertURL);
        } else {
          Observer.emit(AdConsts.MODEL_PLAYLIST_PARSING_ERROR);
          Observer.emit(AdConsts.PLAYLIST_INFO, null);
        }
        break;
    }
    Observer.off([ AdConsts.PLAYLIST_READY, AdConsts.PLAYLIST_ERROR ], _onPlaylistEvent);
  };

  Object.defineProperties(this, {
    'playlist': {
      enumerable: true,
      configurable: false,
      get: function () {
        return _playlist;
      }
    },
    'hasPreroll': {
      enumerable: true,
      configurable: false,
      get: function () {
        return _playlist.hasPreroll;
      }
    }
  });
}
AdModel.prototype.constructor = AdModel;
